import React, { FC, memo } from 'react'
import { Form } from 'antd'
import BrandSelect from '../../components/BrandSelect'

interface IProps<T = any, U = any> {
  setParams: (params?: T, p?: U) => void
}

const BrandInfoPage: FC<IProps> = ({ setParams }) => {
  const handleChange = brandId => {
    setParams({ brandId })
  }
  return (
    <Form.Item label="brandId">
      <BrandSelect
        handleChange={handleChange}
        placeholder="搜索品牌"
        mode="only" // 不合法值  只用于重置select为单选
      />
    </Form.Item>
  )
}

export default memo(BrandInfoPage)
